import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type RowLabelProps = {
	className?: string;
	style?: React.CSSProperties;
	content?: React.ReactNode | JSX.Element;
};

export const RowLabel = ({ className, content, style }: RowLabelProps) => {
	return (
		<div className={clsx(styles.rowLabel, className)} style={{ ...style }}>
			{content}
		</div>
	);
};
